export class PlaceOfApplication {
  id: string;
  name: string;
}
